export enum CountryType {
    LOCAL = "Local", REGIONAL = "Regional", GLOBAL = "Global"
}
